export default __webpack_public_path__ + "static/media/1696.24b08c58.png";